import React, { useState } from 'react'
import LoginForm from '@/components/LoginForm'
import RegisterForm from '@/components/RegisterForm'
import Video from '@/components/Video'

import { StStep, StWrap } from './style.css'

const LoginOrRegister = ({ event, video }) => {
  const [showLogin, setShowLogin] = useState(true)
  const [showRegister, setShowRegister] = useState(false)
  const [showVideo, setShowVideo] = useState(false)
  const [email, setEmail] = useState(false)
  return (
    <>
      {showLogin && (
        <StWrap>
          <StStep>
            <div className="text-center">
              <p className="leading-none text-sm sm:text-2xl">
                Para ver el video, debes ingresar primero.
              </p>
              <h3 className="leading-none text-sm sm:text-4xl font-bold">
                Si te registraste previamente, ingresa el correo electrónico con
                el cual te registraste
              </h3>
              <p className="leading-none text-xs sm:text-sm">
                No te preocupes, si no lo hiciste, te registraremos de
                inmediato.
              </p>
              <LoginForm
                event={event}
                tag={false}
                onLogged={() => {
                  setShowLogin(false)
                  setShowVideo(true)
                }}
                onTriggerRegister={email => {
                  setEmail(email)
                  setShowLogin(false)
                  setShowRegister(true)
                }}
              />
            </div>
          </StStep>
        </StWrap>
      )}
      {showRegister && (
        <StWrap>
          <StStep>
            <RegisterForm
              event={event}
              email={email}
              onRegister={() => {
                setShowRegister(false)
                setShowVideo(true)
              }}
              viewvideoaltiro={true}
            />
          </StStep>
        </StWrap>
      )}
      {showVideo && <Video video={video} />}
    </>
  )
}

export default LoginOrRegister
